import {EnrichedAstNode, AstView} from '../../types';
import {shouldRename, recalculateSymbolTable, hasVisualContent, visitorWithContext} from '../../helpers';

/**
 * Move all nodes to be child of parent.
 * Removes nodes with no visual content.
 */
export function flattenTree(tree: EnrichedAstNode, view: AstView) {
    const {meta} = view;

    const nodeList: EnrichedAstNode[] = [];

    visitorWithContext(
        tree,
        meta,
        (currentNode, meta, context) => {
            if (context) {
                return true;
            }

            if (currentNode !== tree) {
                nodeList.push(currentNode);
            }

            if (currentNode.type === 'Text') {
                return true;
            }
            if (
                currentNode.inputLayoutAbstraction.absolutePosition ||
                (currentNode.userInput.lockChildren && !currentNode.meta.systemGenerated)
            ) {
                return true;
            }
            return false;
        },
        false
    );

    nodeList.forEach((currentNode) => {
        if (currentNode.type === 'Text') {
            return;
        }
        if (currentNode.inputLayoutAbstraction.absolutePosition || currentNode.userInput.lockChildren) {
            return;
        }

        if (!hasVisualContent(currentNode) && !shouldRename(currentNode) && currentNode.children.length > 0) {
            view.meta.symbolTable.userNamesList.push({
                name: currentNode.name,
                children: currentNode.children.map((child) => child.internalId).sort(),
            });
        }

        currentNode.children = [];
    });
    const sortedList = [...nodeList].sort((a, b) => b.zIndex - a.zIndex);

    if (tree.type !== 'Text') {
        tree.children = sortedList.filter((node) => {
            if (node.type !== 'Frame') {
                return true;
            }

            if (hasVisualContent(node) || node.children.length > 0) {
                return true;
            }
            return false;
        });
    }
    recalculateSymbolTable(view);

    return;
}
